export default __webpack_public_path__ + "static/media/Backoffice.5e4ba53e.png";